<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add a Warehouse Space</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">Warehouse*</label>
            <v-select
              v-if="warehouses.length > 0"
              required
              :options="warehouses"
              item-value="id"
              item-text="warehouse_name"
              v-model="location.warehouse_id"
            />
            <span v-else class="has-text-grey-light">
              No warehouses available
            </span>
          </div>

          <div class="field">
            <label class="label">Space Name*</label>
            <v-text-field 
              required
              placeholder="Enter Space Name"
              v-model="location.location_name">
            </v-text-field>
          </div>

          <div class="field">
            <label class="label">Space Description</label>
            <v-text-area 
              placeholder="Enter Space Description"
              rows="3"
              v-model="location.location_desc">
            </v-text-area>
          </div>

          <div class="field">
            <label class="label">Space Code*</label>
            <v-text-field 
              required
              placeholder="Enter Space Code"
              v-model="location.location_code">
            </v-text-field>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addNew()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VTextArea from '@/components/base/VTextArea'
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    warehouseId: {
      type: [String, Number]
    }
  },
  components: { 
    VTextArea,
    VTextField, 
    VForm, 
    VSelect
  },
  data() {
    return {
      location: {
        warehouse_id: null,
        location_name: null,
        location_desc: null,
        location_code: null
      },
      valid: false,
    }
  },
  computed: {
    ...mapState("warehouses", ["warehouses"])
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("warehouses", ["getWarehouses"]),
    ...mapActions("warehouseLocations", [
      "addLocation"
    ]),
    initialize() {
      if (this.warehouses.length == 0) {
        this.getWarehouses();
      }

      if (this.warehouseId) {
        this.location.warehouse_id = this.warehouseId;
      }
    },
    addNew() {
      this.addLocation({ 
        data: this.location
      }).then(() => this.close(true));
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
